import React, { Component } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";

import { toast, Toaster } from "react-hot-toast";
import * as myConstList from "../../BaseUrl";
import AccountList from "../partials/account/AccountList";
import socketIOClient from "socket.io-client";
const jwtToken = localStorage.getItem("jwtToken");
const baseUrl = myConstList.baseUrl;
const callBackBaseUrl = myConstList.callBackBaseUrl;
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
};
class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
    };
    this.state = {
      currentRecord: {
        id: "",
        fname: "",
        lname: "",
        dob: "",
        gender: "",
        email: "",
        mobile: "",
        password: "",
        password2: "",
        profileDataFound: false,
        thirdPhaseConfig:"",
      },
    };

    this.getData = this.getData.bind(this);
  }

  getData() {
    // console.log(window.location.origin);
    const { user } = this.props.auth;
    axios
      .post(baseUrl + "api/profile-data", { _id: user.id })
      .then((res) => {
        this.setState({
          records: res.data.data,
        });
      })
      .catch();
  }
  componentDidMount() {
    if (!this.props.auth.isAuthenticated) {
      window.location = callBackBaseUrl + "?callBack=" + window.location.origin;
    }
    this.getData();
    const socket = socketIOClient(baseUrl, { query: "jwtToken=" + jwtToken });
    this.setState({ socketCollect: socket });
    var collectThis = this;
    socket.on("connect", () => {
      collectThis.setState({ currentSocketId: socket.id });
      socket.emit("callDashboardData");
      socket.emit("config3rdphase");
    });
    
    socket.on("3rdPhaseConfig", function (apiRespData) {      
      if (socket.id == collectThis.state.currentSocketId) {
        var arr = [];
        arr['account']= apiRespData.data[0].account;
        arr['transaction']= apiRespData.data[0].transaction;
        collectThis.setState({ thirdPhaseConfig: arr });
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.account !== undefined &&
      nextProps.account.account !== undefined &&
      nextProps.account.account.data !== undefined &&
      nextProps.account.account.data.data !== undefined &&
      nextProps.account.account.data.message !== undefined &&
      nextProps.account.account.data.success
    ) {
      console.log("dataaSuceesss=");
      toast.success(nextProps.account.account.data.message, toastStyles);
      // $('#add-user-modal').modal('hide');
    }
    this.getData();
  }

  render() {
    return (
      <>
        <Navbar urlPath={false} symbol={false} thirdPhaseConfig={this.state.thirdPhaseConfig}/>
        <Sidebar />
        <div className="container">
          <div className="in_page ">
            <div className=" padding_d">
              <AccountList record={this.state.records} />
            </div>
          </div>
        </div>        
        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
      </>
    );
  }
}

Account.propTypes = {
  auth: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  account: state.account,
  records: state.records,
});

export default connect(mapStateToProps)(Account);
